const apiUrl = process.env.REACT_APP_API_URL;
export const PostProjectesIdAlumnesIdValidacio = async ( id_grup : string, id_projecte : string, id_tasca : string, checkAlumne : number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/grup/${id_grup}/tasca/${id_tasca}/validacio`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body:  JSON.stringify( {
                avaluacio : checkAlumne
            })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
